// extracted by mini-css-extract-plugin
export default {"fr-view":"Standalone_fr-view__99iSY","question":"Standalone_question__Ci5y0"};